import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MainRoutingModule } from './main-routing.module';

import { SharedModule } from '@carm/shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { MainBodyBottomComponent } from './main-body/main-body-bottom/main-body-bottom.component';
import { MainBodyContainerComponent } from './main-body/main-body-container/main-body-container.component';
import { MainBodySectionComponent } from './main-body/main-body-section/main-body-section.component';
import { MainFooterBottomSectionComponent } from './main-footer/main-footer-bottom-section/main-footer-bottom-section.component';
import { MainFooterContainerComponent } from './main-footer/main-footer-container/main-footer-container.component';
import { MainFooterMainSectionComponent } from './main-footer/main-footer-main-section/main-footer-main-section.component';
import { MainHeaderBottomSectionComponent } from './main-header/main-header-bottom-section/main-header-bottom-section.component';
import { MainHeaderContainerComponent } from './main-header/main-header-container/main-header-container.component';
import { MainHeaderLangSectionViewComponent } from './main-header/main-header-lang-section-view/main-header-lang-section-view.component';
import { MainHeaderLangSectionComponent } from './main-header/main-header-lang-section/main-header-lang-section.component';
import { MainHeaderMainSectionComponent } from './main-header/main-header-main-section/main-header-main-section.component';
import { MainHeaderProgramMenuViewComponent } from './main-header/main-header-program-menu-view/main-header-program-menu-view.component';
import { MainHeaderTopSectionComponent } from './main-header/main-header-top-section/main-header-top-section.component';
import { PublicMenuHtmlEnComponent } from './main-header/public-menu-html-en/public-menu-html-en.component';
import { PublicMenuHtmlFrComponent } from './main-header/public-menu-html-fr/public-menu-html-fr.component';
import { MenuService } from './main-header/services/menu.service';
import { ReplaceUnderscorePipe } from '@carm/shared/pipes/replace-underscore.pipe';
import { MainHeaderSetupMyPortalComponent } from './main-header/main-header-setup-my-portal/main-header-setup-my-portal.component';
import { MainBodyBottomComponentService } from '@carm/base-layout/main/main-body/main-body-bottom/services/main-body-bottom-component.service';

@NgModule({
  declarations: [
    MainHeaderLangSectionComponent,
    MainHeaderLangSectionViewComponent,
    MainHeaderTopSectionComponent,
    MainHeaderMainSectionComponent,
    MainHeaderBottomSectionComponent,
    MainBodySectionComponent,
    MainFooterMainSectionComponent,
    MainFooterBottomSectionComponent,
    MainHeaderContainerComponent,
    MainFooterContainerComponent,
    MainBodyContainerComponent,
    MainBodyBottomComponent,
    MainHeaderProgramMenuViewComponent,
    PublicMenuHtmlEnComponent,
    PublicMenuHtmlFrComponent,
    ReplaceUnderscorePipe,
    MainHeaderSetupMyPortalComponent,
  ],
  imports: [
    CommonModule,
    MainRoutingModule,
    PipesModule,
    TranslateModule,
    SharedModule,
  ],
  providers: [ MenuService, MainBodyBottomComponentService ],
  exports: [
    MainHeaderContainerComponent,
    MainFooterContainerComponent,
    MainBodyContainerComponent,
    MainBodyBottomComponent,
  ],
})
export class MainModule {}
